import {
	Card,
	CardContent,
	OutlinedInput,
	IconButton,
	InputAdornment,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	Menu,
	MenuItem,
	Button,
	TablePagination,
	FormControlLabel,
	Switch,
	Typography,
	Box,
	Chip,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Link } from "react-router-dom";
import ConfirmationDialog from "../ConfirmationDialog/ConfirmationDialog";
import config from "../../utils/config";
import { toast } from "react-toastify";
import moment from "moment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useState, useEffect } from "react";
import { useDebouncedCallback } from "use-debounce";
import universities from "../../utils/universities";
import axios from "axios";

const numRows = 10;

function StudentRequests(props) {
	const [studentRequests, setStudentRequests] = useState([]);
	const [searchText, setSearchText] = useState("");
	const [searchPaid, setSearchPaid] = useState(false);
	const [searchDate, setSearchDate] = useState(null);
	const [menuAnchorEl, setMenuAnchorEl] = useState(null);
	const [menuRequest, setMenuRequest] = useState(null);
	const [menuPaid, setMenuPaid] = useState(false);
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [confirmationMessage, setConfirmationMessage] = useState("");
	const [confirmationOnYes, setConfirmationOnYes] = useState(null);
	const [confirmationOnClose, setConfirmationOnClose] = useState(null);
	const [page, setPage] = useState(0);
	const [totalRows, setTotalRows] = useState(0);
	const [lastPage, setLastPage] = useState(0);

	useEffect(() => {
		props.setTitle("Student Requests");
	}, []); // eslint-disable-line

	useEffect(() => {
		setStudentRequests([]);
		setPage(0);
		setLastPage(0);
		setSearchText("");
		fetchStudentRequests(0);
	}, [props.organization]); // eslint-disable-line

	useEffect(() => {
		onSearchTextPaidDateChanged();
	}, [searchText, searchPaid, searchDate]); // eslint-disable-line

	const onSearchTextPaidDateChanged = useDebouncedCallback(() => { // eslint-disable-line
		setPage(0);
		setLastPage(0);
		fetchStudentRequests(0);
	}, 500);

	const handlePageChange = (_, newPage) => {
		if (newPage > lastPage) {
			fetchStudentRequests(newPage);
			setLastPage(newPage);
		}

		setPage(newPage);
	}

	const exportStudentRequests = useDebouncedCallback(() => {
		axios
			.post(
				`${config.API_ENDPOINT}/student-requests/${props.organization}/export`,
				{},
				{ headers: { "x-access-token": localStorage.getItem("access-token") } })
			.then(() => toast.success("You will receive an email with your file soon"))
			.catch(err => {
				switch (err.response?.status) {
					case 401:
						localStorage.removeItem("access-token");
						window.location.replace("/login");
						break;
					default:
						toast.error("An unexpected error has occurred");
						break;
				}
			});
	}, 500, { leading: true });

	const findEsnCountry = (organizationId) => {
		for (let esnCountry of Object.keys(universities)) {
			if (Object.keys(universities[esnCountry]).includes(organizationId)) {
				return esnCountry;
			}
		}

		return null;
	}

	const copyIframe = async () => {
		let text = `<iframe frameborder="0" scrolling="yes" src="${config.WEB_ENDPOINT}/iframes/student-request/${findEsnCountry(props.organization)}" style=" min-height: 700px; overflow-y: scroll; width: 100%; "></iframe>`;
		await navigator.clipboard.writeText(text);
		toast.success("Copied!");
	}

	const fetchNumStudentRequests = () => {
		var q = `${config.API_ENDPOINT}/student-requests/${props.organization}/count`;

		if (searchText !== "") {
			q += `?search=${searchText}`;
		}

		if (searchDate) {
			if (q.includes("?")) {
				q += '&';
			} else {
				q += '?';
			}

			q += `searchDate=${searchDate.startOf("day").valueOf()}`;
		}

		if (searchPaid) {
			if (q.includes("?")) {
				q += '&';
			} else {
				q += '?';
			}

			q += "paid=true";
		}

		axios
			.get(q, { headers: { "x-access-token": localStorage.getItem("access-token") } })
			.then(res => setTotalRows(res.data.count))
			.catch(() => toast.error("An unexpected error has occurred"));
	};

	const fetchStudentRequests = useDebouncedCallback((page) => {
		fetchNumStudentRequests();

		let q = `${config.API_ENDPOINT}/student-requests/${props.organization}/all?page=${page}&numRows=${numRows}`;

		if (searchPaid) {
			q += "&paid=true";
		}

		if (searchText !== "") {
			q += "&search=" + searchText;
		}

		if (searchDate) {
			q += "&searchDate=" + searchDate.startOf("day").valueOf();
		}

		axios
			.get(q, { headers: { "x-access-token": localStorage.getItem("access-token") } })
			.then(res => {
				if (page === 0) {
					setStudentRequests(res.data);
				} else {
					setStudentRequests([...studentRequests, ...res.data]);
				}
			})
			.catch(err => {
				switch (err.response?.status) {
					case 401:
						localStorage.removeItem("access-token");
						window.location.replace("/login");
						break;
					default:
						toast.error("An unexpected error has occurred");
						break;
				}
			});
	}, 500);

	const deleteRequest = useDebouncedCallback((requestId) => {
		axios
			.delete(`${config.API_ENDPOINT}/student-requests/${props.organization}/${requestId}`, { headers: { "x-access-token": localStorage.getItem("access-token") } })
			.then(() => {
				toast.success("Success!");
				setConfirmationOpen(false);
				setMenuAnchorEl(null);
				setPage(0);
				setLastPage(0);
				fetchStudentRequests(0);
			})
			.catch(err => {
				switch (err.response?.status) {
					case 401:
						localStorage.removeItem("access-token");
						window.location.replace("/login");
						break;
					case 404:
						toast.warn("You don't have enough permissions to delete this request");
						setConfirmationOpen(false);
						setMenuAnchorEl(null);
						break;
					default:
						toast.error("An unexpected error has occurred");
						break;
				}
			});
	}, 500, { leading: true });

	const showDeleteDialog = (requestId) => {
		let confirmationMessage = "Are you sure you want to delete this student request?";
		if (menuPaid) {
			confirmationMessage += " WARNING: This request has already been paid for. Make sure to issue a refund.";
		}

		setConfirmationMessage(confirmationMessage);
		setConfirmationOnClose(() => () => {
			setConfirmationOpen(false);
			setMenuAnchorEl(null);
		});
		setConfirmationOnYes(() => () => {
			setConfirmationOpen(false);
			setMenuAnchorEl(null);
			deleteRequest(requestId);
		});
		setConfirmationOpen(true);
	}

	return (
		<Box>
			<Box sx={{ mb: 4, pb: 3, borderBottom: "1px solid rgba(19, 33, 68, 0.1)" }}>
				<Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>Student Requests</Typography>
				<Typography variant="body2" sx={{ color: "text.secondary" }}>
					View and manage student registration requests
				</Typography>
			</Box>

			<Card sx={{ mb: 3 }}>
				<CardContent>
					<Box sx={{ display: "flex", gap: 1, mb: 2 }}>
						<Button
							variant="outlined"
							size="small"
							startIcon={<ContentCopyIcon />}
							onClick={copyIframe}
							sx={{ textTransform: "none", fontWeight: 600 }}
						>
							Copy Embed Code
						</Button>
						<Button
							variant="outlined"
							size="small"
							startIcon={<FileDownloadIcon />}
							onClick={exportStudentRequests}
							sx={{ textTransform: "none", fontWeight: 600 }}
						>
							Export
						</Button>
					</Box>

					<Accordion defaultExpanded>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography sx={{ fontWeight: 600 }}>Filters</Typography>
							{(searchText || searchDate || searchPaid) && (
								<Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
									{searchText && <Chip label={`Search: ${searchText}`} size="small" />}
									{searchDate && <Chip label={`Date: ${moment(searchDate).format("DD/MM/YYYY")}`} size="small" />}
									{searchPaid && <Chip label="Paid Only" size="small" color="success" />}
								</Box>
							)}
						</AccordionSummary>
						<AccordionDetails sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" }, gap: 2, pt: 2 }}>
							<DatePicker
								label="Request Date"
								format="DD/MM/YYYY"
								value={searchDate}
								onChange={(date) => setSearchDate(date)}
								slotProps={{ textField: { fullWidth: true } }}
							/>
							<OutlinedInput
								fullWidth
								placeholder="Search: Name / Email / Passport"
								value={searchText}
								onChange={(ev) => setSearchText(ev.target.value)}
								endAdornment={
									searchText && (
										<InputAdornment position="end">
											<IconButton size="small" onClick={() => setSearchText("")}>
												<ClearIcon fontSize="small" />
											</IconButton>
										</InputAdornment>
									)
								}
							/>
							<FormControlLabel
								control={
									<Switch
										checked={searchPaid}
										onChange={ev => setSearchPaid(ev.target.checked)}
										size="small"
									/>
								}
								label="Paid Requests Only"
							/>
						</AccordionDetails>
					</Accordion>
				</CardContent>
			</Card>

			<Card>
				<CardContent sx={{ p: 0 }}>
					<TableContainer>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell>Date/Time</TableCell>
									<TableCell>Full Name</TableCell>
									<TableCell>Email</TableCell>
									<TableCell>Nationality</TableCell>
									<TableCell>University</TableCell>
									<TableCell align="center">Paid</TableCell>
									<TableCell align="right">Actions</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{studentRequests.length === 0 ? (
									<TableRow>
										<TableCell colSpan={7} align="center" sx={{ py: 4 }}>
											<Typography variant="body2" sx={{ color: "text.secondary" }}>
												No student requests found
											</Typography>
										</TableCell>
									</TableRow>
								) : (
									studentRequests
										.slice(
											page * numRows,
											page * numRows + numRows
										)
										.map((request) => (
											<TableRow key={request._id} hover>
												<TableCell sx={{ fontSize: 14 }}>
													{moment(request.timestamp).format("DD/MM/YYYY HH:mm")}
												</TableCell>
												<TableCell sx={{ fontWeight: 500 }}>{request.name}</TableCell>
												<TableCell sx={{ fontSize: 14 }}>{request.email}</TableCell>
												<TableCell sx={{ fontSize: 14 }}>{request.country}</TableCell>
												<TableCell sx={{ fontSize: 14 }}>{request.university}</TableCell>
												<TableCell align="center">
													<Chip
														label={request.paid ? "Yes" : "No"}
														size="small"
														color={request.paid ? "success" : "default"}
														variant={request.paid ? "filled" : "outlined"}
													/>
												</TableCell>
												<TableCell align="right">
													<IconButton
														size="small"
														onClick={(ev) => {
															setMenuAnchorEl(ev.currentTarget);
															setMenuRequest(request._id);
															setMenuPaid(request.paid);
														}}
													>
														<MoreVertIcon fontSize="small" />
													</IconButton>
												</TableCell>
											</TableRow>
										))
								)}
							</TableBody>
						</Table>
					</TableContainer>
					<TablePagination
						rowsPerPageOptions={[numRows]}
						rowsPerPage={numRows}
						component="div"
						count={totalRows}
						page={page}
						onPageChange={handlePageChange}
					/>
				</CardContent>
			</Card>

			<Menu
				anchorEl={menuAnchorEl}
				open={menuAnchorEl != null}
				keepMounted
				onClose={() => setMenuAnchorEl(null)}
			>
				<Link
					to={`/finish-request/${menuRequest}`}
					style={{ color: "inherit", textDecoration: "inherit" }}
				>
					<MenuItem>Complete Request</MenuItem>
				</Link>
				{props.user.accessLevel <= 4 && (
					<MenuItem
						onClick={() => showDeleteDialog(menuRequest)}
					>
						Delete
					</MenuItem>
				)}
			</Menu>

			<ConfirmationDialog
				open={confirmationOpen}
				message={confirmationMessage}
				onYes={confirmationOnYes}
				onClose={confirmationOnClose}
			/>
		</Box>
	);
}

export default StudentRequests;